/**
 * FloatingChat — no-op placeholder.
 *
 * The AI Ops chat surface (Claude Sonnet 4.6 via Emergent LLM key) is
 * currently GATED for HIPAA/PHI review — see handoff summary Issue 1
 * "Chat LLM PHI/BAA Policy (P3)". Until Davinder greenlights the
 * BAA-safe path, this component renders nothing to keep the chrome
 * clean and prevent accidental PHI exposure via the chat overlay.
 *
 * When the policy is resolved, restore the floating trigger + drawer here.
 */
export default function FloatingChat() {
  return null;
}
